import api from './api';

export type IntegracaoExecucao = {
  id: string;
  disparo: 'MANUAL' | 'AGENDADO';
  status: 'EM_EXECUCAO' | 'SUCESSO' | 'FALHA';
  forceReimport: boolean;
  usuario: string | null;
  iniciadoEm: string;
  finalizadoEm: string | null;
  resumo: Record<string, unknown> | null;
  erro: string | null;
};

export type Integracao = {
  id: string;
  nome: string;
  descricao: string;
  origem: string;
  agendamento: string | null;
  suportaForceReimport: boolean;
  configurada: boolean;
  emExecucao: boolean;
  ultimaExecucao: IntegracaoExecucao | null;
};

const listar = async (): Promise<Integracao[]> => {
  const response = await api.get('/admin/integracoes');
  return response.data as Integracao[];
};

const historico = async (id: string, limite = 10): Promise<IntegracaoExecucao[]> => {
  const response = await api.get(`/admin/integracoes/${id}/execucoes`, { params: { limite } });
  return response.data as IntegracaoExecucao[];
};

const sincronizar = async (id: string, forceReimport = false): Promise<IntegracaoExecucao> => {
  const response = await api.post(`/admin/integracoes/${id}/sync`, null, { params: { forceReimport } });
  return response.data as IntegracaoExecucao;
};

export default { listar, historico, sincronizar };
